export const QueryKeys = {
    getAddresses: "get-addresses",
    getProfile: "get-profile",
    getServiceCloudToken: "get-service-cloud-token",
    getPostalCode: "get-postal-code",
    algoliaProducts: "algolia-products",
    getYotpoReviews: "get-yotpo-reviews",
    getPaymentMethods: "get-payment-methods",
    getDeliveryMethods: "get-delivery-methods",
    amazonPaySignature: "amazon-pay-signature",
    getGlobalAddresses: "get-global-addresses",
    verifyEmail: "verify-email",
    getParcelShops: "get-parcel-shops",
    getStores: "get-stores",
    getTrustpilotReviews: "get-trustpilot-reviews",
    getMultipleProducts: "get-multiple-products",
    getOrderDocument: "get-order-document",
    getProduct: "get-product",
    getLoyaltyTransactionsPoints: "get-loyalty-transactions-points",
} as const;
